import React, { useContext, useEffect } from 'react';
import EditForm from './components/EditForm/EditForm';
// import TranslationsForm from './components/TranslationForm/TranslationsForm';
import { EditTeaserContext, IEditTeaserContext } from '../../editTeaserState/editTeaserContext';
import style from './Forms.module.scss';

const Forms: React.FC = () => {
	const { visibleForm } = useContext<IEditTeaserContext>(EditTeaserContext);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [visibleForm]);

	return (
		<div className={style.container} data-test="Forms">
			<EditForm isVisible={visibleForm === 'mainForm'} />
			{/* <TranslationsForm isVisible={visibleForm === 'translations'} /> */}
		</div>
	);
};

export default Forms;
